import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyC6kCM5Y-5JmQGoywUpQhtg304y2XeHoF4',
  authDomain: 'blnj-bf732.firebaseapp.com',
  databaseURL: 'https://blnj-bf732-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'blnj-bf732',
  storageBucket: 'blnj-bf732.appspot.com',
  messagingSenderId: '348101151482',
  appId: '1:348101151482:web:866e9327b631b596ab9743',
}

export const FirebaseApp = initializeApp(firebaseConfig)
export const FirebaseDatabase = getDatabase(FirebaseApp)
